/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { get } from '../fn/current-user/get';
import { Get$Params } from '../fn/current-user/get';
import { settings } from '../fn/current-user/settings';
import { Settings$Params } from '../fn/current-user/settings';
import { SettingsDto } from '../models/settings-dto';
import { User } from '../models/user';

@Injectable({ providedIn: 'root' })
export class CurrentUserService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `currentUserControllerGet()` */
  static readonly CurrentUserControllerGetPath = '/users/current';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `get()` instead.
   *
   * This method doesn't expect any request body.
   */
  get$Response(params?: Get$Params, context?: HttpContext): Observable<StrictHttpResponse<User>> {
    return get(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `get$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  get(params?: Get$Params, context?: HttpContext): Observable<User> {
    return this.get$Response(params, context).pipe(map((r: StrictHttpResponse<User>): User => r.body));
  }

  /** Path part for operation `currentUserControllerSettings()` */
  static readonly CurrentUserControllerSettingsPath = '/users/current/settings';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `settings()` instead.
   *
   * This method doesn't expect any request body.
   */
  settings$Response(params?: Settings$Params, context?: HttpContext): Observable<StrictHttpResponse<SettingsDto>> {
    return settings(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `settings$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  settings(params?: Settings$Params, context?: HttpContext): Observable<SettingsDto> {
    return this.settings$Response(params, context).pipe(
      map((r: StrictHttpResponse<SettingsDto>): SettingsDto => r.body)
    );
  }
}
